import { insuranceImportService } from "./service";
import { InsuranceImportWithJobs } from "./types";

export const getInsuranceImport = async (insuranceImportId: string) => {
  const { data } = await insuranceImportService.get<InsuranceImportWithJobs>(
    `/${insuranceImportId}`
  );

  return data;
};
